import React from "react";
import { Card, Section } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import styles from "./diffChanges.module.scss";
const ChangeCategoryCard = ({ title, added, removed, }) => {
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, { as: "h2", details: [
                added.length > 0 ? `${added.length.toLocaleString()} added` : null,
                removed.length > 0
                    ? `${removed.length.toLocaleString()} removed`
                    : null,
            ].filter((detail) => detail !== null) }, title),
        React.createElement(Card.Content, { className: styles["category-grid"] },
            React.createElement(Section, null,
                React.createElement(Section.Title, { as: "h3" }, "Added"),
                React.createElement(Section.Content, { className: styles["change-list"] }, added)),
            React.createElement(Section, null,
                React.createElement(Section.Title, { as: "h3" }, "Removed"),
                React.createElement(Section.Content, { className: getClassName(styles["change-list"], styles.muted) }, removed)))));
};
export default ChangeCategoryCard;
//# sourceMappingURL=ChangeCategoryCard.js.map